module.exports = __webpack_public_path__ + "static/media/default-user-grey.311ba5f3.png";